// src/api/notificationService.js
// -----------------------------------------------------------------------------
// Calls for Notification_TBL (Requirement #22: in-app notifications for every
// action, plus Additional Requirement: email channel).
// -----------------------------------------------------------------------------
import axiosClient from './axiosClient';
import ENDPOINTS from './endpoints';

const notificationService = {
  getAll: (params = {}) => axiosClient.get(ENDPOINTS.NOTIFICATIONS, { params, skipGlobalLoader: true }),
  getByUser: (userID, params = {}) => axiosClient.get(ENDPOINTS.NOTIFICATION_BY_USER(userID), { params, skipGlobalLoader: true }),
  getUnreadByUser: (userID, params = {}) => axiosClient.get(ENDPOINTS.NOTIFICATION_UNREAD_BY_USER(userID), { params, skipGlobalLoader: true }),
  markAsRead: (notificationID) => axiosClient.put(ENDPOINTS.NOTIFICATION_MARK_READ(notificationID), null, { skipGlobalLoader: true }),
  markAllAsRead: (userID) => axiosClient.put(ENDPOINTS.NOTIFICATION_MARK_ALL_READ(userID), null, { skipGlobalLoader: true }),
  delete: (notificationID) => axiosClient.delete(ENDPOINTS.NOTIFICATION_BY_ID(notificationID), { skipGlobalLoader: true }),
};

export default notificationService;
